// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"_2NDGl","productDetailsHideOnHover":"_2jyF- _1T_Er","leftText":"_30pA4","centerText":"IrErv","rightText":"_3biQi"};